import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const MaturityProLayout = lazy(() =>
  import('../components/maturity-pro/MaturityProLayout').then((m) => ({ default: m.MaturityProLayout }))
)
const MatProHubPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.HubPage }))
)
const MatProCockpitPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CockpitPage }))
)
const MatProScorePage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.ScorePage }))
)
const MatProMaturitePage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MaturitePage }))
)
const MatProCmmiPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CmmiPage }))
)
const MatProCobitPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CobitPage }))
)
const MatProIso33001Page = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.Iso33001Page }))
)
const MatProCustomModelPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CustomModelPage }))
)
const MatProCampaignsPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CampaignsPage }))
)
const MatProDimensionsPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.DimensionsPage }))
)
const MatProQuestionnairesPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.QuestionnairesPage }))
)
const MatProBenchmarkingPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.BenchmarkingPage }))
)
const MatProGapAnalysePage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.GapAnalysePage }))
)
const MatProRoadmapPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProRoadmapPage }))
)
const MatProProgressionPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.ProgressionPage }))
)
const MatProObjectifsPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.ObjectifsPage }))
)
const MatProFrameworksPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProFrameworksPage }))
)
const MatProMappingPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MappingPage }))
)
const MatProCertificationPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.CertificationPage }))
)
const MatProBenchmarksPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.BenchmarksPage }))
)
const MatProReportExecPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProReportExecPage }))
)
const MatProIntegrationPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProIntegrationPage }))
)
const MatProAuditTrailPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProAuditTrailPage }))
)
const MatProSettingsPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProSettingsPage }))
)
const MatProOutilsPage = lazy(() =>
  import('../pages/maturity-pro').then((m) => ({ default: m.MatProOutilsPage }))
)
const MatProBenchmarkIntelligencePage = lazy(() =>
  import('../pages/maturity-pro/BenchmarkIntelligencePage').then((m) => ({ default: m.BenchmarkIntelligencePage }))
)

export const maturityProRoutes: RouteObject[] = [
  {
    path: '/maturity-pro',
    element: <MaturityProLayout />,
    children: [
      { index: true, element: <MatProHubPage /> },

      { path: 'hub', element: <MatProHubPage /> },
      { path: 'cockpit', element: <MatProCockpitPage /> },
      { path: 'score', element: <MatProScorePage /> },
      { path: 'maturite', element: <MatProMaturitePage /> },
      { path: 'cmmi', element: <MatProCmmiPage /> },
      { path: 'cobit', element: <MatProCobitPage /> },
      { path: 'iso33001', element: <MatProIso33001Page /> },
      { path: 'custom-model', element: <MatProCustomModelPage /> },
      { path: 'campaigns', element: <MatProCampaignsPage /> },
      // Profile-MD aliases for /maturity-pro/assessment*
      { path: 'assessment', element: <MatProCampaignsPage /> },
      { path: 'assessment/new', element: <MatProCampaignsPage /> },
      { path: 'dimensions', element: <MatProDimensionsPage /> },
      { path: 'questionnaires', element: <MatProQuestionnairesPage /> },
      { path: 'benchmarking', element: <MatProBenchmarkingPage /> },
      { path: 'gap-analyse', element: <MatProGapAnalysePage /> },
      { path: 'roadmap', element: <MatProRoadmapPage /> },
      { path: 'progression', element: <MatProProgressionPage /> },
      { path: 'objectifs', element: <MatProObjectifsPage /> },
      { path: 'frameworks', element: <MatProFrameworksPage /> },
      { path: 'mapping', element: <MatProMappingPage /> },
      { path: 'certification', element: <MatProCertificationPage /> },
      { path: 'benchmarks', element: <MatProBenchmarksPage /> },
      { path: 'report-exec', element: <MatProReportExecPage /> },
      { path: 'integrations', element: <MatProIntegrationPage /> },
      { path: 'audit-trail', element: <MatProAuditTrailPage /> },
      { path: 'settings', element: <MatProSettingsPage /> },
      { path: 'outils', element: <MatProOutilsPage /> },
      { path: 'benchmark-intelligence', element: <MatProBenchmarkIntelligencePage /> },
    ],
  },
]
